import React, { ReactNode, createContext, useContext, FC, useState } from 'react';

import { INotificationDTO } from 'src/api/dtos';
import { useMessageCenterEdit } from 'src/features/message-center/providers/MessageCenterEditProvider';

type MessageCenterSelectionProps = {
  selected: INotificationDTO | undefined;
  onSelect: (notification: INotificationDTO) => void;
  onClear: () => void;
};

const MessageCenterSelectionContext = createContext<MessageCenterSelectionProps>({} as MessageCenterSelectionProps);

export const useMessageCenterSelection = (): MessageCenterSelectionProps =>
  useContext<MessageCenterSelectionProps>(MessageCenterSelectionContext);

export const MessageCenterSelectionProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const { onCancel } = useMessageCenterEdit();

  const [selected, setSelected] = useState<INotificationDTO>();

  const handleSelect = (notification: INotificationDTO) => {
    setSelected(notification);
    onCancel();
  };

  const handleClear = () => {
    setSelected(undefined);
  };

  return (
    <MessageCenterSelectionContext.Provider value={{ selected, onSelect: handleSelect, onClear: handleClear }}>
      {children}
    </MessageCenterSelectionContext.Provider>
  );
};
